export default __webpack_public_path__ + "static/media/Boots of the Oxmal.5b15edba.jpg";